import React from "react";

/**
 * Mini trust strip — placed above the global footer.
 * Reinforces social proof + concrete stats site-wide. Premium minimal styling.
 */
export default function MiniTrustStrip() {
  return (
    <section
      data-testid="mini-trust-strip"
      className="bg-[#FAF5EC] border-t border-[#6E1F2C]/15"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-10 md:py-12 flex flex-col items-center text-center gap-5">
        <p className="font-serif-display text-base md:text-lg text-[#1C110C] tracking-tight max-w-3xl">
          Trusted by <em className="not-italic text-[#6E1F2C]">homeowners, offices, healthcare facilities, and leading developers</em> across the UAE.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[10px] md:text-[11px] tracking-[0.32em] uppercase text-[#7A6B5F]">
          <span data-testid="mini-trust-years" className="text-[#6E1F2C]">Established 1993</span>
          <span aria-hidden="true" className="text-[#D4A963]">·</span>
          <span data-testid="mini-trust-projects">2,300+ Projects Delivered</span>
          <span aria-hidden="true" className="text-[#D4A963]">·</span>
          <span data-testid="mini-trust-coverage">Serving Clients Across the UAE</span>
        </div>
        <p
          data-testid="mini-trust-authority"
          className="text-[10px] md:text-[11px] tracking-[0.36em] uppercase text-[#6E1F2C] pt-2 border-t border-[#6E1F2C]/15 mt-2"
          style={{ minWidth: "min(100%, 540px)" }}
        >
          UAE Since 1993  ·  Turnkey Specialists  ·  In-House Manufacturing
        </p>
      </div>
    </section>
  );
}
